<template>
  <div>
    <div v-for="(apparatus, index) in subscriptionList" :key="index">
      <div v-if="apparatus != undefined">
        <div class="card mt-3" header-bg-variant="white">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-auto">
                <h5 class="mb-0 pb-0">
                  <div>
                    <b-badge
                      v-if="apparatus.subscriptionStatus === 2"
                      variant="light"
                      class="current-plan-badge mb-2 border-primary text-primary"
                      >{{ $t('xCurrentPlan') }}</b-badge
                    >
                  </div>
                  <span data-test-hook="product-name">
                    {{ apparatus.subscriptionProductName }}
                  </span>
                </h5>
              </div>
            </div>
            <div v-if="apparatus.subscriptionStatus === 2">
              <div class="row mb-2">
                <div class="col">
                  <span data-test-hook="billing-date-header-text">
                    {{ $t('xPlanStatus') }}
                  </span>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col">
                  <strong data-test-hook="billing-date">
                    {{ $t('xPendingCancellation') }}
                  </strong>
                </div>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col">
                <span data-test-hook="plan-cost-header-text">
                  {{ $t('xPlanCost') }}
                </span>
              </div>
            </div>
            <div class="row mb-4">
              <div class="col">
                <strong data-test-hook="plan-cost">
                  {{
                    '$' + apparatus.subscriptionCost + ' ' + displayLegacyPlanCostCycle(apparatus.subscriptionDuration)
                  }}
                </strong>
              </div>
            </div>
            <div>
              <div class="row mb-2">
                <div class="col">
                  <span v-if="apparatus.subscriptionStatus === 2" data-test-hook="billing-date-header-text">
                    {{ $t('xPlanEndDate') }}
                  </span>
                  <span v-else data-test-hook="billing-date-header-text">
                    {{ $t('xNextBillingDate') }}
                  </span>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col">
                  <strong data-test-hook="billing-date">
                    {{ $moment(apparatus.subscriptionNextBillingDate).format('MM/DD/YYYY') }}
                  </strong>
                </div>
              </div>
            </div>
            <div class="accordion" role="tablist" style="width:100%">
              <div class="accordion-wrapper" style="border: 1px solid lightgrey; padding: 10px; border-radius: 10px;">
                <div v-b-toggle="'collapse-legacy-' + apparatus.apparatusId">
                  <div class="row align-items-center no-gutters">
                    <div class="col align-items-center">
                      <i class="fa-regular fa-circle-info pr-2"></i><strong>{{ $t('xProductsAndFeatures') }}</strong>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-chevron-down when-closed"></i>
                      <i class="fas fa-chevron-up when-open"></i>
                    </div>
                  </div>
                </div>
                <b-collapse :id="'collapse-legacy-' + apparatus.apparatusId">
                  <div class="row">
                    <div class="col">
                      <hr class="mx-0 px-0" />
                    </div>
                  </div>
                  <div class="row mb-2">
                    <div class="col">
                      <p class="mb-0 pb-0">
                        <strong data-test-hook="products-included-text">
                          {{ $t('xProductsIncludedInPlan') }}
                          {{ apparatus.subscriptionProductName }}
                        </strong>
                      </p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-0">
                      <ul id="productsCoveredTanks" style="list-style-type: none; padding-inline-start: 16px;">
                        <div class="row">
                          <div class="col d-flex align-items-center">
                            <b-img :src="getApparatusIcon(apparatus.apparatusType)" class="mr-2" />
                            <span>{{ apparatus.apparatusName }}</span>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                  <div class="row mt-0 mb-2">
                    <div class="col">
                      <p class="mb-0 pb-0">
                        <strong data-test-hook="features-included-text">
                          {{ $t('xFeaturesIncludedInPlan') }}
                          {{ apparatus.subscriptionProductName }}
                        </strong>
                      </p>
                    </div>
                  </div>
                  <div v-if="apparatus.subscriptionProductId == tankUtilityPremiumProductId">
                    <div class="row mb-3">
                      <div class="col d-flex align-items-center">
                        <b-img :src="require('@/assets/images/tank.svg')" class="mr-2" />
                        <span data-test-hook="features-included-list">
                          {{ $t('xSubFeaturesFmFuelLevelHistoryWarningsBattery') }}
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col icon-and-text">
                        <!-- need to change to a list -->
                        <i class="far fa-fw fa-circle-check mr-1"></i>
                        <span data-test-hook="features-included-monitor-list">
                          {{ $t('xFeaturesIncludedTankUtilityAnnuallySubscriptionFeature2') }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="row mb-3">
                      <div class="col d-flex align-items-center">
                        <b-img :src="require('@/assets/images/generator.svg')" class="mr-2" />
                        <span data-test-hook="features-included-list">
                          {{ $t('xFeaturesInDMHsb1') }}
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col icon-and-text">
                        <i class="far fa-fw fa-circle-check mr-1"></i>
                        <span data-test-hook="features-included-monitor-list">
                          {{ $t('xFeaturePremiumMonitoringForOneHsb') }}
                        </span>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
              <div v-if="!purchasedOnWeb">
                <div class="row">
                  <div class="col">
                    <span data-test-hook="manage-plan-text">
                      <!-- need to decide text based on subscription -->
                      {{ $t('xManagePlanOnApple') }}
                    </span>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col">
                    <!-- need to decide link based on subscription -->
                    <a href="https://account.apple.com/account/manage/section/subscriptions">
                      <span data-test-hook="manage-plan-text">
                        {{ 'https://account.apple.com/account/manage/section/subscriptions.' }}
                      </span>
                    </a>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn btn-warning"
                  @click="openMobileApp()"
                  data-test-hook="OpenMobileAppBtn"
                >
                  {{ $t('xOpenMobileApp') }}
                </button>
              </div>
              <div
                v-else-if="apparatus.subscriptionNextBillingDate != null && apparatus.subscriptionStatus !== 2"
                class="mt-3"
              >
                <button
                  type="button"
                  class="btn btn-warning"
                  @click="
                    endDate = apparatus.subscriptionNextBillingDate
                    apparatusId = apparatus.apparatusId
                    apparatusType = apparatus.apparatusType
                    openModal('cancel-subscription-modal')
                  "
                  :title="$t('xManageYourPlanBtn')"
                  data-test-hook="ManageYourPlanBtn"
                >
                  <i class="fas fa-pencil" />&nbsp;{{ $t('xManageYourPlanBtn') }}
                </button>
              </div>
              <div class="row mt-3" v-if="apparatus.subscriptionStatus !== 2">
                <div class="col">
                  <p data-test-hook="AutoRenewMsg" class="auto-renew-message text-small">
                    {{ $t('xThisSubscriptionWillAutoRenewShortVersion') }}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="apparatus.subscriptionStatus === 2">
              <hr />
              <b-badge variant="primary" class="mb-2 mt-2 border-primary pending-change-badge">{{
                $t('xPendingChange')
              }}</b-badge>
              <div class="row mb-2">
                <div class="col">
                  <span data-test-hook="no-plan-status">{{ $t('xPlanStatus') }}</span>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col">
                  <strong>{{ $t('xNoPlan') }}</strong>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col">
                  <span data-test-hook="effective-cancel-date">{{ $t('xChangeEffectiveDate') }}</span>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col">
                  <strong>{{ $moment(apparatus.subscriptionNextBillingDate).format('MM/DD/YYYY') }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CancelSubscriptionModal
      :isCancelLegacy="true"
      :endDate="endDate"
      :cancelLegacyApparatusId="apparatusId"
      :cancelLegacyApparatusType="apparatusType"
      :cancelSubscriptionApparatuses="[]"
      :cancelSubscriptionProductId="null"
      :cancelSubscriptionStore="null"
    />
  </div>
</template>
<script>
import * as Constants from '@/constants'
import CancelSubscriptionModal from './CancelSubscriptionModal.vue'

export default {
  components: {
    CancelSubscriptionModal
  },
  data() {
    return {
      apparatusId: null,
      apparatusType: null,
      endDate: null,
      purchasedOnWeb: true
    }
  },
  props: ['subscriptionList'],
  computed: {
    dealerManagedProductId() {
      return Constants.DealerManagedProductId
    },
    tankUtilityDealerManagedProductId() {
      return Constants.TankUtilityDealerManagedProductId
    },
    tankUtilityPremiumProductId() {
      return Constants.TankUtilityPremiumProductId
    },
    wiFiAnnualProductId() {
      return Constants.WiFiAnnualProductId
    },
    wiFiMonthlyProductId() {
      return Constants.WiFiMonthlyProductId
    }
  },
  methods: {
    displayLegacyPlanCostCycle(duration) {
      if (duration == 1) return this.$t('xPerMonth')
      if (duration == 12) return this.$t('xPerYear')
    },
    getApparatusIcon(type) {
      switch (type) {
        case Constants.HsbApparatusType:
          return require('@/assets/images/generator.svg')
        case Constants.FuelTankApparatusType:
          return require('@/assets/images/tank.svg')
        default:
          return require('@/assets/images/generator.svg')
      }
    },
    openDealerInfo(apparatusId) {
      this.$router.push({
        path: `/details/` + apparatusId + `/preferredDealer`
      })
    },
    openCancelSubscriptionModal(isCancelLegacy, nextBillingDate, apparatusId, apparatusType) {
      this.$emit('openCancelSubscriptionModal', {
        isCancelLegacy: isCancelLegacy,
        endDate: nextBillingDate,
        cancelLegacyApparatusId: apparatusId,
        cancelLegacyApparatusType: apparatusType
      })
    }
  }
}
</script>
<style scoped lang="scss">
.pending-change-badge {
  padding: 8px;
}

.current-plan-badge {
  border: 2px solid;
  padding: 5px;
}
</style>
